module.exports = __webpack_public_path__ + "static/media/forest.2c3b4622.png";